export default __webpack_public_path__ + "static/media/apikey.3435d288.svg";